import { v4 as uuidV4 } from 'uuid'
import { emit } from 'util/realtime'
import debug from 'util/debug'

export function fetchUnreadRoomIds(uuid) {
  return new Promise((resolve, reject) => {
    const requestId = uuid || uuidV4()
    emit('fetchUnreadRooms', { requestId }, (err, unreadRoomIds) => {
      if (err) {
        // TODO: FIX AFTER COLLISION REBASE
        // leaveBreadcrumb('fetchUnreadRooms Error', {
        //   requestId,
        //   errorMessage: err.message,
        // })
        debug(err)
        reject(err)
      } else {
        resolve(unreadRoomIds)
      }
    })
  })
}

export function clearUnreadRoomIds(uuid) {
  return new Promise((resolve, reject) => {
    const requestId = uuid || uuidV4()
    emit('clearUnreadRooms', { requestId }, (err, unreadRoomIds) => {
      if (err) {
        // TODO: FIX AFTER COLLISION REBASE
        // leaveBreadcrumb('clearUnreadRooms Error', {
        //   requestId,
        //   errorMessage: err.message,
        // })
        debug(err)
        reject(err)
      } else {
        resolve(unreadRoomIds)
      }
    })
  })
}
